<template>
  <button type="button">
    <slot/>
  </button>
</template>

<script>
    export default {
        name: "FormButton"
    }
</script>

<style scoped>
  button {
    font-size: 17px;
    line-height: 50px;
    background-color: #244148;
    color: white;
    text-align: center;
    display: block;
    border-radius: 50px;
    padding: 0 24px;
  }

  button:hover {
    cursor: pointer;
  }

  button:disabled {
    cursor: not-allowed;
    opacity: .65;
  }
</style>



// WEBPACK FOOTER //
// src/components/FormButton.vue